"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListAppleShareOfVoiceResponseSchema = exports.AppleShareOfVoiceRowResponseSchema = exports.ListAppleShareOfVoiceQuerySchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
exports.ListAppleShareOfVoiceQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({
    orgRef: typebox_1.Type.Optional(ruby_1.AppleProxyOrgRefSchema),
    appRef: typebox_1.Type.Optional(ruby_1.AppleProxyRefSchema),
    ...core_1.DateFilterFields,
});
exports.AppleShareOfVoiceRowResponseSchema = (0, core_1.StrictObject)({
    orgRef: ruby_1.AppleProxyOrgRefSchema,
    appRef: ruby_1.AppleProxyRefSchema,
    date: core_1.TimestampSchema,
    country: typebox_1.Type.String(),
    term: typebox_1.Type.String(),
    spend: core_1.MoneySchema,
    taps: core_1.CountSchema,
    installs: core_1.CountSchema,
    impressions: core_1.CountSchema,
    impressionShare: typebox_1.Type.String(),
    rank: typebox_1.Type.Integer(),
    searchPopularity: typebox_1.Type.Number(), // 1 to 5 apparently, but its a float in the CSV
});
exports.ListAppleShareOfVoiceResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.AppleShareOfVoiceRowResponseSchema);
